import { render, staticRenderFns } from "./decorateDoc.vue?vue&type=template&id=7d9bcb9e&"
import script from "./decorateDoc.vue?vue&type=script&lang=js&"
export * from "./decorateDoc.vue?vue&type=script&lang=js&"
import style0 from "./decorateDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports